import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DeleteMyAccount } from './delete-myaccount.model';
import * as fromDeleteState from './delete-myaccount.reducer';

export const selectDeleteMyaccountState =
  createFeatureSelector<DeleteMyAccount>('delete-myaccount');
export const selectAuthenticateStatus = createSelector(
  selectDeleteMyaccountState,
  fromDeleteState.authenticateStatus
);
export const selectUnenrollmentStatus = createSelector(
  selectDeleteMyaccountState,
  fromDeleteState.unenrollProgramsStatus
);
export const selectDeleteMyAccountStatus = createSelector(
  selectDeleteMyaccountState,
  fromDeleteState.deleteMyAccountStatus
);
export const selectSendTemplatedEmailStatus = createSelector(
  selectDeleteMyaccountState,
  fromDeleteState.sendTemplatedEmailStatus
);
